// Client-safe reCAPTCHA configuration: site key and the disabled flag. Contains no
// secrets, so it is exported from the client entry. Read at call-time so this module is
// inert if it is ever bundled into the client (process.env is empty there).
export type GoogleRecaptchaPublicConfig = {
    recaptchaSiteKey: string;
    recaptchaV2SiteKey: string;
    recaptchaDisabled: boolean;
};

export namespace GoogleRecaptchaPublicConfig {
    export function fromProcessEnv(): GoogleRecaptchaPublicConfig {
        return {
            recaptchaSiteKey: process.env.RECAPTCHA_SITE_KEY ?? '',
            recaptchaV2SiteKey: process.env.RECAPTCHA_V2_SITE_KEY ?? '',
            recaptchaDisabled: process.env.RECAPTCHA_DISABLED === 'true',
        };
    }
}
